<template>
        <b-button size="sm" @click="doResearch" variant="outline-secondary">
            <b-icon-clipboard-data></b-icon-clipboard-data>
            <span class="ml-2 mr-1">Research</span>
        </b-button>
</template>

<script>
    import searchSitesList from "../../assets/searchSitesList";

    // Store window references globally so they persist across component recreations
    const globalOpenWindows = {};

    export default {
        name: "SearchSite",
        props: [ 'item', 'artist', 'title' ],
        mixins: [ searchSitesList ],
        data() {
            return {
                openWindows: globalOpenWindows
            }
        },
        methods: {
            doResearch() {

                let researchSitesArray = this.searchSites;
                const defaultSearchSites = localStorage.getItem('researchSites');
                if (defaultSearchSites && defaultSearchSites.split(',').length > 0) {
                    researchSitesArray = researchSitesArray.filter((site)=> defaultSearchSites.split(',').includes(site.name))
                }

                for (let i = 0; i < researchSitesArray.length; i++) {
                    let url = researchSitesArray[i].url;
                    url += encodeURIComponent(this.artist) + '+' + encodeURIComponent(this.item.release.titles[0]);
                    console.log(url);
                    console.log(researchSitesArray[i].name);
                    
                    const windowName = researchSitesArray[i].name;
                    const existingWindow = this.openWindows[windowName];
                    const isAmazon = windowName === 'Amazon';
                    
                    console.log('Window tracking:', windowName, 'existing:', !!existingWindow, 'all windows:', Object.keys(this.openWindows));
                    
                    // For Amazon, close existing tab before opening new one
                    if (isAmazon && existingWindow) {
                        console.log('Found existing Amazon window, attempting to close...');
                        try {
                            // Check if window is still open
                            const isClosed = existingWindow.closed;
                            console.log('Amazon window closed?', isClosed);
                            
                            if (!isClosed) {
                                console.log('Attempting to close Amazon window...');
                                existingWindow.close();
                                console.log('Close called, checking if it worked:', existingWindow.closed);
                            }
                        } catch (e) {
                            console.log('Error closing Amazon window:', e);
                        }
                        // Clear the reference and open new window
                        delete this.openWindows[windowName];
                    } else if (isAmazon && !existingWindow) {
                        console.log('No existing Amazon window found in tracking');
                    }
                    
                    // Open new window
                    const newWindow = window.open(url, windowName);
                    this.openWindows[windowName] = newWindow;
                    console.log('Opened window, now tracking:', Object.keys(this.openWindows));
                    
                    // For non-Amazon sites with existing windows, try to navigate
                    if (!isAmazon && existingWindow && !existingWindow.closed) {
                        console.log('Trying to navigate existing window for', windowName);
                        try {
                            existingWindow.location.href = url;
                            existingWindow.focus();
                        } catch (e) {
                            console.log('Failed to navigate, opening new window');
                        }
                    }
                }
                // console.log(this.item);
                
            }
        }
    }
</script>

<style scoped>

</style>